//
import { mapActions } from "vuex"

//
import { ModelDataTable, ModelForm } from "@/components/reusable_components/next"
import QueryModel from "@/models/General/GQuery"
import Translator from "@/services/translator"

//
import fields from "./fields"

//
export default {
    name: "query-create",
    components: {
        ModelDataTable,
        ModelForm,
    },
    computed: {

        /**
         * 
         */
        formProps () {
            return {
                fields,
            }
        },
    },
    data () {
        return {
            formData    : {},
            tableData   : [],
            tableHeaders: [],
            verified    : false,
        }
    },
    methods: {

        //
        ...mapActions( "MenuesModule", {
            setTitleTopBar: "setTitleTopBar",
        }),

        /**
         * 
         */
        create ( model ) {
            model.toCreate().save().then( this.success ).then( this.redirect ).catch( this.error ).then( this.$refs.form.setWait )
        },

        /**
         * 
         */
        error ( error ) {
            this.$toast.error( Translator( QueryModel, error.response.data ) )
        },

        /**
         * 
         */
        mapHeader ( header ) {
            return {
                text    : header,
                value   : header,
            }
        },

        /**
         * 
         */
        raw ( model ) {
            new QueryModel({ id: "run" }).rawQuery( model.query ).get().finally( this.$refs.form.setWait ).then( this.setTableData ).catch( this.error )
        },

        /**
         * 
         */
        redirect () {
            this.$router.push({ name: "query-list" })
        },

        /**
         * 
         */
        reset () {
            this.formData = new QueryModel()
        },

        /**
         * 
         */
        run () {
            this.$refs.form.setWait( true ).then( this.raw )
        },

        /**
         * 
         */
        setTableData ( res ) {
            this.tableHeaders   = Object.keys( res.slice().pop().result.data.slice().pop() || {} ).map( this.mapHeader )
            this.tableData      = res.slice().pop().result.data
            this.verified       = true
        },

        /**
         * 
         */
        submit () {
            this.$refs.form.setWait( true ).then( this.create )
        },

        /**
         * 
         */
        success () {
            this.$toast.success( "Consulta agregada." )
        },
    },
    beforeMount () {
        this.setTitleTopBar( "Crear consulta" )
    },
    mounted () {
        this.reset()
    }
}